// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main[data-v-2167f636]{max-width:100%;overflow:hidden;background-color:var(--general-bg-general)}@media(min-width:1024px){.main[data-v-2167f636]{min-height:600px}}@media screen and (min-width:568px)and (orientation:landscape)and (max-height:500px)and (max-width:980px){.main[data-v-2167f636]{min-height:100px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
